import { ExcalidrawFontFace } from "@excalidraw/excalidraw/fonts/ExcalidrawFontFace";
import { XiaolaiFontFaces } from "@excalidraw/excalidraw/fonts/Xiaolai";

let isXiaolaiRegistered = false;

export const ensureXiaolaiFont = () => {
  if (typeof document === "undefined" || !document.fonts) {
    return;
  }

  if (isXiaolaiRegistered) {
    return;
  }

  isXiaolaiRegistered = true;

  XiaolaiFontFaces.forEach(({ uri, descriptors }) => {
    const fontFace = new ExcalidrawFontFace("Xiaolai", uri, descriptors)
      .fontFace;
    if (!document.fonts.has(fontFace)) {
      document.fonts.add(fontFace);
    }
  });

  // Trigger a small load so CJK text uses the same font as the canvas.
  void document.fonts.load('16px "Xiaolai"', "速度");
};
